import React, { useState, useEffect } from 'react';
import { useLanguage } from './contexts/LanguageContext';
import './css/hero-blur.css';

/**
 * useIsDesktop - returns true when the viewport is at desktop width.
 *
 * The blur-backdrop hero wrapper (.hero-img) is ONLY rendered on desktop.
 * On mobile we render the bare <img className="logobackground-layer">
 * exactly like the original markup, so the App.css mobile media queries
 * (width:110vw, height:55vh, top:-5vh, ...) apply unmodified and mobile
 * stays identical to the pre-blur behaviour.
 *
 * 769px is the breakpoint: App.css uses max-width:768px for its mobile
 * queries, so desktop starts at 769px.
 */
function useIsDesktop() {
  const query = '(min-width: 769px)';
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsDesktop(e.matches);
    setIsDesktop(mql.matches);
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    // Safari < 14 fallback
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);
  return isDesktop;
}

const Principles = ({ currentProgram, currentBackgroundArray, programmes, onNavigate }) => {
  const { t } = useLanguage();
  const isDesktop = useIsDesktop();

  const heroImage = (
    <img
      className="logobackground-layer"
      src={currentBackgroundArray[currentProgram]}
      alt=""
      loading="eager"
      decoding="async"
    />
  );

  return (
    <div className="principles-section">
      <div className="logo-container">
        <div className="oval"></div>
        {/*
          Desktop only: wrap the hero <img> in .hero-img for the
          blur-backdrop effect. On mobile the wrapper is NOT rendered, so
          the bare <img className="logobackground-layer"> is styled purely
          by App.css media queries - identical to the pre-blur behaviour.
        */}
        {isDesktop ? (
          <div
            className="hero-img"
            style={{ "--src": "url(" + currentBackgroundArray[currentProgram] + ")" }}
          >
            {heroImage}
          </div>
        ) : (
          heroImage
        )}
        <div className="logoforeground-layer" />
      </div>
      <div className="aboutus">
        <h2 className="title-values">{t('principles.title')}</h2>
        <div className="programmes">
          {programmes.map((programme, index) => (
            <div key={index} className={`programme-item ${index === currentProgram ? 'visible' : ''}`}>
              <div className="programme-content">
                <img src={programme.image} alt={programme.title} className="programme-image" loading="eager" decoding="async" />
                <h5 className={`programme-title programme-title-${index}`}>
                  <a className='programme-titletext'>{t(`principles.programmes.${index}.title`)}</a>
                </h5>
              </div>
              <div className="programme-text">
                <p className="programme-text-up">{t(`principles.programmes.${index}.text`)}</p>
                <p className="programme-text-down">{t(`principles.programmes.${index}.text2`)}</p>
              </div>
            </div>
          ))}
        </div>
        <button
          className="btn donatenow"
          onClick={() => onNavigate('beapart')}
        >
          {t('principles.becomePart')}
        </button>
      </div>
    </div>
  );
};

export default Principles;
